import React from 'react';
import { FiCopy, FiEdit } from 'react-icons/fi';
import TableColumnTitle from '../../../../components/_table/TableColumnTitle';
import { setDateFormat } from '../../../../lib/moment';
import {
  HOME_TYPE,
  WIDGET_LAYOUT_TYPE_TEXT,
  WIDGET_STATUS,
  WIDGET_STATUS_TEXT,
  WIDGET_TYPE_TEXT,
} from '../../../../constants/service/app/widgetConstants';
import { setWidgetExposurePeriod } from '../../../../lib/utils/widgetUtils';
import { reDirectPage, setDash, setDetailPageUrl, openNewWindow } from '../../../../lib/common';
import {
  MAIN_PAGE_MANAGEMENT_URL_PATH,
  SUB_PAGE_MANAGEMENT_URL_PATH,
  WIDGET_COPY_URL_PATH,
  WIDGET_EDIT_URL_PATH,
} from '../../../../constants/service/common/urlConstants';
import Anchor from '../../../../components/link/Anchor';
import Button from '../../../../components/Button';

/**
 *  위젯 컬림
 */
export const columns = (data) => {
  const { getWidgetPreviewData, deleteWidget } = data;

  return [
    {
      title: <TableColumnTitle title={'수정'} />,
      dataIndex: 'edit',
      render: (value, record) => (
        <FiEdit
          onClick={() =>
            reDirectPage({
              path: setDetailPageUrl(WIDGET_EDIT_URL_PATH, record.id),
              state: {
                widgetType: record.widgetType,
              },
            })
          }
        />
      ),
    },
    {
      title: <TableColumnTitle title={'복사'} />,
      dataIndex: 'copy',
      render: (value, record) => (
        <FiCopy
          onClick={() =>
            reDirectPage({
              path: setDetailPageUrl(WIDGET_COPY_URL_PATH, record.id),
              state: {
                widgetType: record.widgetType,
              },
            })
          }
        />
      ),
    },
    {
      title: <TableColumnTitle title={'상태'} />,
      dataIndex: 'status',
      render: (value) => WIDGET_STATUS_TEXT[value],
    },
    {
      title: <TableColumnTitle title={'위젯 ID'} />,
      dataIndex: 'id',
      render: (value) => (
        <Anchor
          color="primary"
          isUnderLine
          text={value}
          onClick={() => openNewWindow(setDetailPageUrl(WIDGET_EDIT_URL_PATH, value))}
        />
      ),
    },
    {
      title: <TableColumnTitle title={'위젯 타입'} />,
      dataIndex: 'widgetType',
      render: (value, record) => (
        <Anchor
          color="primary"
          isUnderLine
          text={WIDGET_TYPE_TEXT[value]}
          onClick={() =>
            getWidgetPreviewData({
              widgetId: record.id,
            })
          }
        />
      ),
    },
    {
      title: <TableColumnTitle title={'레이아웃 타입'} />,
      dataIndex: 'layoutType',
      render: (value, record) => WIDGET_LAYOUT_TYPE_TEXT[record.widgetType][value],
    },
    {
      title: <TableColumnTitle title={'메인 타이틀'} />,
      dataIndex: 'mainTitle',
      render: (value) => setDash(value),
    },
    {
      title: <TableColumnTitle title={'서브 타이틀'} />,
      dataIndex: 'subTitle',
      render: (value) => setDash(value),
    },
    {
      title: <TableColumnTitle title={'메모'} />,
      dataIndex: 'memo',
      ellipsis: true,
      render: (value) => setDash(value),
    },
    {
      title: <TableColumnTitle title={'노출기간'} />,
      dataIndex: 'exposurePeriod',
      render: (value, record) => setWidgetExposurePeriod(record.exposureStartDate, record.exposureEndDate),
    },
    {
      title: <TableColumnTitle title={'노출된 페이지'} />,
      dataIndex: 'linkedPageId',
      render: (value, record) =>
        value ? (
          <Anchor
            isUnderLine
            color="primary"
            text={record.linkedPageType === HOME_TYPE.MAIN ? '메인 페이지' : record.linkedPageTitle}
            onClick={() =>
              openNewWindow(
                record.linkedPageType === HOME_TYPE.MAIN
                  ? MAIN_PAGE_MANAGEMENT_URL_PATH
                  : setDetailPageUrl(SUB_PAGE_MANAGEMENT_URL_PATH, value),
              )
            }
          />
        ) : (
          '-'
        ),
    },
    {
      title: <TableColumnTitle title={'생성일'} />,
      dataIndex: 'createDate',
      render: (value) => setDateFormat(value),
    },
    {
      title: <TableColumnTitle title={'삭제하기'} />,
      dataIndex: 'delete',
      render: (value, record) =>
        record.status === WIDGET_STATUS.ACTIVE ? (
          '비 활성만 가능'
        ) : (
          <Button isRadius color="red" text="삭제" onClick={() => deleteWidget(record.id)} />
        ),
    },
  ];
};
